// extracted by mini-css-extract-plugin
export default {"SearchWrapper":"Search_SearchWrapper__QclMf"};